import React, { type ReactNode } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deferTracking, sendGAEvent } from '@noths/polaris-client-google-analytics';

import { ListingsHeader } from 'src/components/organisms/ListingsHeader/ListingsHeader';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectTotalActiveNonTaxonomyOptions } from 'src/redux/productsQuery/selectors/selectors';
import { actions } from 'src/redux/productsQuery/slice';
import type { AppThunkDispatch } from 'src/redux/store';

export const ListingsHeaderContainer = ({
  children,
  stickyTopBanner = false,
}: {
  children?: ReactNode;
  stickyTopBanner?: boolean;
}) => {
  const dispatch = useDispatch<AppThunkDispatch>();
  const state = useSelector((state: ReduxApplicationState) => state);
  const totalActiveFacetOptions = selectTotalActiveNonTaxonomyOptions(state);

  const openListingsControlsDrawer = () => {
    // Defer off the interaction's critical path: fire-and-forget, does not gate the drawer opening.
    deferTracking(() =>
      sendGAEvent({
        event: 'custom_event_v2',
        event_name: 'filter_interaction',
        event_details: 'open modal',
        content_type: 'filters',
        modal_details: {
          name: 'plp_filter_facet',
          type: 'mobile_drawer',
          action: 'open',
          page_type: 'plp',
        },
      }),
    );
    dispatch(actions.openModal());
  };

  return (
    <ListingsHeader
      onButtonClick={openListingsControlsDrawer}
      stickyOffsetPx={stickyTopBanner ? 36 : 0}
      totalActiveFacetOptions={totalActiveFacetOptions}
    >
      {children}
    </ListingsHeader>
  );
};
